import { render, staticRenderFns } from "./SubscriptionsNew.vue?vue&type=template&id=3a63e6a6"
import script from "./SubscriptionsNew.vue?vue&type=script&lang=ts"
export * from "./SubscriptionsNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports